import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import clsx from 'clsx';

export type H3Props = ComponentPropsWithoutRef<'h3'> & {
    className?: string;
    children: ReactNode;
};

function H3({ className = '', children, ...restProps }: H3Props) {
    return (
        <h3 className={clsx('font-GBold text-xl', className)} {...restProps}>
            {children}
        </h3>
    );
}

export default H3;
